import { render, staticRenderFns } from "./simulator.vue?vue&type=template&id=1f608cf4&lang=pug&"
import script from "./simulator.vue?vue&type=script&lang=js&"
export * from "./simulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports